import React from 'react';
import { useSelector } from 'react-redux';
import { IconButton } from '../../../CommonComponents/OPL/IconButton/IconButton';
import { useRouteParams } from '../../hooks/useRouteParams';
import { downloadFile } from '../../../CommonUtils/downloadFile';
import { Tooltip } from '../../../CommonComponents/OPL/Tooltip/Tooltip';
import { toast } from '../../../CommonComponents/OPL/Toast/Toast';
import { MESSAGES } from '../../../CommonConstants';
import { selectCanExportPersonalFinancesToCsv } from '../../../CommonSelectors/CommonAreaSelector';
import { usePositionsDetailsCsvMutation } from '../../api/usePositionsDetailsCsvMutation';
import { usePositionsDate } from '../../hooks/usePositionsDate';

interface Props {
  selectedGroupName: string;
}

export const PositionsDetailsCsvExport = (props: Props) => {
  const canExportPersonalFinancesToCsv = useSelector(selectCanExportPersonalFinancesToCsv);

  if (!canExportPersonalFinancesToCsv) {
    return null;
  }

  return <Content {...props} />;
};

const Content = ({ selectedGroupName }: Props) => {
  const { clientId, accountId, groupId } = useRouteParams();

  const date = usePositionsDate();

  const {
    mutateAsync: downloadCsv,
    isLoading: isDownloadingCsv,
  } = usePositionsDetailsCsvMutation();

  const onDownloadCsv = async () => {
    try {
      const { fileName, fileBlob } = await downloadCsv({
        clientId,
        date,
        accountId,
        groupId,
        selectedGroupName,
      });

      downloadFile(fileName || 'positions_details.csv', fileBlob);
    } catch (error) {
      console.error(error);
      toast.error(MESSAGES.GENERIC_ERROR);
    }
  };

  return (
    <Tooltip content="Export to Excel" placement="bottom-start" delay={500}>
      <IconButton
        icon="far fa-file-export"
        variant="secondary"
        isLoading={isDownloadingCsv}
        onClick={onDownloadCsv}
      />
    </Tooltip>
  );
};
